import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

SecondaryButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node
};

export default function SecondaryButton(props) {
  const {
    disabled = false,
    className,
    href,
    children,
    ...rest
  } = props;

  const TagName = href ? 'a' : 'button';
  const target = href?.startsWith('/') ? undefined : '_blank';

  return (
    <TagName
      href={href}
      type={href ? undefined: "button"}
      target={target}
      className={classNames(
        `inline-flex items-center justify-center gap-1
         bg-transparent text-cs-navy-800
         border-2 border-cs-navy-800
         text-[17px] font-bold leading-6
         px-4 py-3 rounded-full cursor-pointer
         focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2
         w-full md:w-auto min-h-[52px] md:min-h-10`,
        !disabled && 'hover:bg-cs-navy-800/10 active:bg-cs-navy-800/20',
        disabled && 'opacity-40 cursor-not-allowed pointer-events-none',
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </TagName>
  );
}
